import { StrictMode } from 'react'
import axios from 'axios'
import { createRoot } from 'react-dom/client'

import './styles/reset.scss'
import '@kenect-ut/kenect-ui-kit/lib/styles.css'
import './styles/app.scss'
import App from './app/App'
import { localConfig, networkConfig } from './app/config'
import AppError from './app/errors/AppError'
import Fire from './app/firebaseConfig'

const root = createRoot(document.getElementById('root'))

const renderApp = () => {
  root.render(<App />)
}

const renderError = () => {
  root.render(
    <StrictMode>
      <AppError />
    </StrictMode>,
  )
}

const startAppWithConfig = (response) => {
  try {
    networkConfig.setConfig(response.data)
    networkConfig.check()
    Fire.initialize()
    renderApp()
  } catch (err) {
    console.error(err)
    renderError()
  }
}

const getLocalConfig = () => Promise.resolve({ data: localConfig })
const getRemoteConfig = () => axios.get('/config')

const getConfigPromise = window.location.host.includes('localhost')
  ? getLocalConfig()
  : getRemoteConfig()

getConfigPromise.then(startAppWithConfig)
